import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  useMemo,
} from "react";
import { logLoadTrace } from "../../../src/firebase";
import {PendingButtons} from "../viewOrder/PendingButtons";
import RenderSvg from "../../components/renderSvg/RenderSvg";
import { Button } from "@mantine/core";
import BigDecimal from "js-big-decimal";
import {
  viewPrimaryOrderRowsData,
  popupType,
  OrderType,
} from "../../types/types";
import dayjs from "dayjs";
import {
  getSinglePrimaryOrder,
  updateOrder,
  updateOrderStatus,
} from "../../services/manageOrderService";
import { createScrollHandler, handleScroll, roundWithPointSixRule, safeStringify, truncateToTwoDecimals } from "../../components/dms_common/DmsUtils";
import { useNavigate, useParams } from "react-router-dom";
import {
  getMetaData1,
  getViewPrimaryOrderConfig,
  getViewPrimaryOrderEditConfig,
  metaData2,
} from "./ViewPrimaryOrderConfig";
import {
  defaultSearchFunction,
  filterData,
} from "../../components/dms_common/DmsCommonServices";
import "../manageBasket/ManageBasket.css";
import "./ViewPrimaryOrder.css";
import { Loader } from "../../components/loader/Loader";
import { ConfirmationPopUp } from "../../components/popup/confirmationPopUp";
import { GenericPopUp } from "../../components/popup/genericPopUp";
import FormHeader from "../../components/dms_common/FormHeader";
import CustomAccordian from "../../components/dms_common/CustomAccordian";
import CustomTablewithTotalInfo from "../../components/dms_common/CustomTablewithTotalInfo";
import Search from "../../components/dms_common/Search";
import { getConfigData } from "../../services/configurationService";
import { analytics, performance } from "../../../src/firebase";
import { logEvent } from "firebase/analytics";
import { trace, PerformanceTrace } from "firebase/performance";
import { setDiscountModalState } from "../../stateManagement/actions/claims";
import { useDispatch } from "react-redux";
import NewDiscountModalPrimary from "../claimsNew/modals/NewDiscountModalPrimary";
import { UOM } from "../createSecondaryOrder/CreateSecondaryOrderType";
import {
  formatEditedQuantities,
  getValidateRequestBody,
  updateMultiQtyInCart,
  updateQuantityInCart,
} from "../createSecondaryOrder/CreateSecondaryOrderService";
import { Cart, Catalogue } from "../createSecondaryOrder/models";
import {
  buttonLoading,
  GenericModal,
  getBatchCodes,
  getGenericModalProps,
  initialGenericModalProps,
  keysToKeep,
  keysToKeepOD,
  modifyCartToValidate,
} from "../viewOrder/ViewOrderUtils";
import {
  createCatalogue,
  createPricingForArsSkus,
} from "../../services/catalogueService";
import { getDataFromLocalDb } from "../../services/dbService";
import "./ViewPrimaryOrder.css";
import { ChannelkartNetworkPost } from "../../services/networkService";
import CustomGenericModal from "../../components/dms_common/CustomGenericModal";
import OrderCancelModal from "../viewOrder/OrderCancelModal";
import BorderHeading from "../../components/heading/BorderHeading";
import { Alert, Snackbar } from "@mui/material";
import { sendSlackAlert, SlackChannel } from "../../services/slackService";
import TextSwitcher, { TextSwitcherItemObject } from "../../components/dms_common/TextSwitcher";

export type ARSQuantities = {
  caseQuantity: number;
  pieceQuantity: number;
  otherUnitQuantity: number;
}

export type ARSPricing = {
  casePtr: number;
  piecePtr: number;
  otherUnitPtr: number;
}

export type ARSBatchMap = Record<string, ARSQuantities>;
export type ARSPricingMap = Record<string, ARSPricing>;


const ViewPrimaryOrder = () => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { packUnitLabelPrimary,caseUnitLabelPrimary,otherUnitLabelPrimary,currency } = ConfigDictionary;
  const arsPercentage = JSON.parse(localStorage.getItem("authContext") ?? "{}")?.user?.arsPercentage;
  const arsType = JSON.parse(localStorage.getItem("authContext") ?? "{}")?.user?.arsType;
  const { orderId } = useParams();
  const [searchedValue, setSearchedValue] = useState("");
  const [textSwitcherItems, setTextSwitcherItems] = useState<TextSwitcherItemObject[]>([]);
  const [textSwitcherItemsForAmountTrail, setTextSwitcherItemsForAmountTrail] = useState<TextSwitcherItemObject[]>([]);
  const [rows, setRows] = useState<viewPrimaryOrderRowsData[]>([]);
  const [data, setData] = useState<viewPrimaryOrderRowsData[]>([]);
  const [loader, setLoader] = useState(true);
  const [openGenericModal, setOpenGenericModal] = useState<boolean>(false);
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [genericMessage, setGenericMessage] = useState<string>("");
  const [confirmationPopUp, setConfirmationPopUp] = useState(false);
  const [totalFooterValue, setTotalFooterValue] = useState<any[]>([]);
  const [popUpMessage, setPopUpMessage] = useState<string>("");
  const [disableActionButtons, setDisableActionButtons] = useState(false);
  const [actionButtons, setActionButtons] = useState<any[]>([]);
  const [totalTaxAmount, setTotalTaxAmount] = useState<number>(0);
  const [orderData, setOrderData] = useState<any>({});
  const [isScrolling, setIsScrolling] = useState(false);
  const [selectedRejectionReason, setSelectedRejectionReason] =
    useState<string>(``);
  const [rejectionReasons, setRejectionReasons] = useState<string[]>([]);
  const [genericModalProps, setGenericModalProps] = useState<GenericModal>(
    initialGenericModalProps
  );
  const navigate = useNavigate();
  const [saveChangesLoading, setSaveChangesLoading] = useState<boolean>(false);
  const enableARSConfig = useRef<boolean>(false);
  const { fetchPricingBySalesrep, batchIdConfiguration = false } = ConfigDictionary;
  const stagesRef = useRef<any>();
  const isArsOrderRef = useRef<boolean>(false);
  const [orderTrackingConfig, setOrderTrackingConfig] = useState<any[]>([]);
  const popUpSuccessMethod = useRef<any>();
  const [currencySymbol, setCurrencySymbol] = useState<string>("");
  const [deliveryDatePrimary, setDeliveryDatePrimary] = useState<string>("");
  const [cart, setCart] = useState<Cart>({});
  const [orderCancelModalOpen, setOrderCancelModalOpen] =
    useState<boolean>(false);
  const [selectedSkuCode, setSelectedSkuCode] = useState<any>({});
  const [orderStatusChangeLoading, setOrderStatusChangeLoading] =
    useState<string>("");
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const useNewOrderStatusUpdateAPI = useRef<boolean>(false);
  const [catalogue, setCatalogue] = useState<Catalogue[]>([]);
  const disableStockCheck = useRef<boolean>(false);
  const disableSchemeCheck = useRef<boolean>(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [arsVoilation, setArsVoilation] = useState(false);
  const [arsVoilationMsg, setArsVoilationMsg] = useState<String>("");
  const [editLoading, setEditLoading] = useState<boolean>(false);

  const [scrollTop, setScrollTop] = useState<number>(0); 
  const scrollRef = useRef<HTMLDivElement>(null);
  const [allowTableScroll, setAllowTableScroll] = useState<boolean>(false);
  const [dontAllowContainerScroll, setDontContainerScroll] = useState(true);

  const showTaxPercentage = useRef<boolean>(true);
  const initialNetAmountBeforeSaving = useRef<number>(0);
  const disableARSEdit = useRef<boolean>(false);
  const [isARSAmountValid, setIstARSAmountValid] = useState<boolean>(arsType?.toLowerCase() !== "amount");
  const [rejectionReasonString, setRejectionReasonString] =
    useState<string>("");
  const dispatch = useDispatch();
  const openPopup = useCallback((message: string, type: popupType) => {
    setPopupType(type);
    setGenericMessage(message);
    setOpenGenericModal(true);
  }, []);

  const onCustomAccordionToggle = (isExpanded: boolean) => {
    setIsScrolling(!isExpanded);
  };
      const default_items: TextSwitcherItemObject[] = [
          {
              label: "Attention:",
              text: `${arsType?.toLowerCase() === "quantity" ? "Quantity" : "Amount"} restrictions are applied on this order based on configured limits`,
              svgIcon: "disclaimerIcon",
              itemStyles: {
                container: { backgroundColor: "#FFF1F1" },
                text: { color: "#B54747" },
                svg: { color: "#B54747", width: "1em" },
              },
            }
      ];

  useEffect(() => {
    if(arsType && arsPercentage) {
      if("quantity" !== arsType?.toLowerCase() && isEditing) {
        getAndSetTextSwitcherItems()
      } else {
        setTextSwitcherItems(default_items);
      }
    } else {
      if(!(arsType && arsPercentage)) setTextSwitcherItems([]);
      setTextSwitcherItemsForAmountTrail([]);
    }
  }, [isEditing])

  const handleClickAddMore = async () => {
    if (openInvalidOrderModal()) return;

    const arsMap: ARSBatchMap = rows?.filter(s => s?.source?.toLowerCase() === "ars").reduce((acc, row) => {
    const batchCode = row?.batchCode;
      if (batchCode) {
        acc[batchCode] = {
          caseQuantity: row?.actualCaseQuantity ?? 0,
          pieceQuantity: row?.actualPieceQuantity ?? 0,
          otherUnitQuantity: row?.otherUnitQuantity ?? 0,
        };
      }
      return acc;
    }, {} as ARSBatchMap);
    let arsPricingMap: ARSPricingMap = orderData?.orderDetails?.filter((s: any) => s?.source?.toLowerCase() === "ars")
      ?.reduce((acc: ARSPricingMap, s: any) => {
        if (s?.batchCode) {
          acc[s?.batchCode] = {
            casePtr: Number(s?.casePrice) ?? 0,
            piecePtr: Number(s?.price) ?? 0,
            otherUnitPtr: Number(s?.otherUnitPrice) ?? 0
          };
        }
        return acc;
      }, {}) ?? {};

    navigate(
      `/dashboard/purchase/viewPrimaryOrders/addMore/${orderData?.id}`,
      {
        state: enableARSConfig?.current
          ? { arsMap, arsPricingMap }
          : undefined,
      }
    );
  };

const getAndSetTextSwitcherItems = (row?: any) => {
  if(!arsPercentage || !arsType) return;

  let lowerBound = 0;
  let upperBound = 0;
  if("quantity" === arsType?.toLowerCase() && row) {
    [lowerBound, upperBound] = getQuantityBounds(row?.["actualCaseQuantity"]);
  } else {
    [lowerBound, upperBound] = getAmountBounds();
  }

  const items: TextSwitcherItemObject[] = [
      {
          label: "Attention:",
          text:("quantity" === arsType?.toLowerCase()) ? `Allowed quantity edit range for this sku: ${upperBound} ${caseUnitLabelPrimary} to ${lowerBound} ${caseUnitLabelPrimary}` : `Order Amount can only be edited within the range ${currency} ${truncateToTwoDecimals(lowerBound)} - ${currency} ${truncateToTwoDecimals(upperBound)}`,
          svgIcon: "disclaimerIcon",
          itemStyles: {
            container: { backgroundColor: "#FFF1F1" },
            text: { color: "#B54747" },
            svg: { color: "#B54747", width: "1em" },
          },
        }
  ];

  setTextSwitcherItems(items);
};

  const toggleTaxInfoCollapsedStatus = (
    paramRow: viewPrimaryOrderRowsData,
    collapsed: boolean
  ) => {
    setRows((prevRows: viewPrimaryOrderRowsData[]) => {
      return prevRows.map((prevRow: viewPrimaryOrderRowsData) =>
        paramRow?.id === prevRow?.id ? { ...prevRow, collapsed } : prevRow
      );
    });
  };

  const populateCartDuringEditOrder = async (data: any) => {
    try {
      let orderedBatchCodes: string | string[] =
        getBatchCodes(
          data?.orderDetails
            ?.map((item: any) => (item?.type !== "freeItem" ? item : null))
            ?.filter(Boolean)
        ) ?? "";

      orderedBatchCodes = orderedBatchCodes?.split(",") ?? [];
      let arsPricingMap: ARSPricingMap = orderData?.orderDetails?.filter((s: any) => s?.source?.toLowerCase() === "ars")
        ?.reduce((acc: ARSPricingMap, s: any) => {
          if (s?.batchCode) {
            acc[s?.batchCode] = {
              casePtr: Number(s?.casePrice) ?? 0,
              piecePtr: Number(s?.price) ?? 0,
              otherUnitPtr: Number(s?.otherUnitPrice) ?? 0
            };
          }
          return acc;
        }, {}) ?? {};
      const pricingData = await createCatalogue(
        OrderType.PRIMARY,
        data?.outletCode,
        isArsOrderRef.current ? false : !disableSchemeCheck.current,
        orderedBatchCodes?.filter(s => !(Object.keys(arsPricingMap) as Array<string>).includes(s)),
        fetchPricingBySalesrep && fetchPricingBySalesrep
          ? data?.loginId
          : undefined,
        undefined,
        undefined,
      );

      if (
        pricingData &&
        Array.isArray(pricingData) &&
        pricingData?.length == 0
      ) {
        await sendSlackAlert(
          SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
          "Pricing Data Not Found - ViewPrimaryOrder.tsx",
          `No pricing data found for order ${orderId}`,
          safeStringify({ orderId, data, orderedBatchCodes, arsPricingMap })
        );
        setGenericModalProps(
          getGenericModalProps(
            "error",
            "Some items in this order could not be edited due to missing/incorrect pricing data. Please update the data in the MDM & Integration Page."
          )
        );
        return "invalidPricing";
      }

      const catalogueData = await getDataFromLocalDb("PrimaryCatalogue");
      const dbResult = await getDataFromLocalDb("Product");
      const products: any = dbResult?.data?.[0]?.data ?? {};
      let catalogue = catalogueData?.data as Catalogue[];
      if(arsPricingMap) {
        let arsCat = createPricingForArsSkus(arsPricingMap, products);
        catalogue = [...catalogue, ...arsCat];
      }
      setCatalogue(catalogue);
      data?.orderDetails
        ?.filter((sku: any) => sku?.type !== "freeItem")
        ?.forEach((order: any) => {
          const {
            batchCode,
            caseQuantity,
            pieceQuantity,
            otherUnitQuantity,
            initialNormalizedQuantity,
          } = order;
          if (initialNormalizedQuantity > 0) {
            updateMultiQtyInCart(
              batchCode,
              {
                caseQuantity: caseQuantity,
                otherUnitQuantity: otherUnitQuantity,
                pieceQuantity: pieceQuantity,
              },
              { outletCode: orderData?.outletCode },
              catalogue,
              setCart
            );
          }
        });
    } catch (err: any) {
      await sendSlackAlert(
        SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
        "Error Populating Cart - ViewPrimaryOrder.tsx",
        `Failed to populate cart for order ${orderId}. Error: ${(err as Error).message}`,
        safeStringify({ err, orderId, orderData })
      );
      console.error(err);
      if (err?.message === "pricing") {
        setGenericModalProps(
          getGenericModalProps(
            "error",
            "⚠️  Unable to fetch pricing details. Please try again later.",
            "Ok",
            ``,
            () => {
              setGenericModalProps(initialGenericModalProps);
              setIsEditing(false);
            }
          )
        );
      } else if (err?.message === "offers") {
        setGenericModalProps(
          getGenericModalProps(
            "error",
            "⚠️  Unable to load offer details. Please refresh or try again.",
            "Ok",
            ``,
            () => {
              setGenericModalProps(initialGenericModalProps);
              setIsEditing(false);
            }
          )
        );
      } else {
        setGenericModalProps(
          getGenericModalProps("error", `Order with Id ${orderId} not found`)
        );
      }
    }
  };

  const handleInputDecimalChange = (
    paramRow: any,
    changedValue: string,
    type: UOM
  ) => {
    if (type === UOM.CASE) {
      setRows((prevRows) =>
        prevRows?.map((row) => {
          if (row?.batchCode === paramRow?.batchCode) {
            return {
              ...row,
              "caseQuantityInput": changedValue,
            };
          }
          return row;
        })
      );
    }
  };

const hasRealChanges = () => {
  // Deep clone to avoid mutating
  const validOrderData = JSON.parse(JSON.stringify(orderData));

  // Filter free items from orderData
  const validOrderDetails: any = validOrderData?.orderDetails?.filter(
    (sku: any) => sku?.type !== "freeItem"
  );

  // Filter free items from rows
  const validRows = rows.filter((row: any) => !row?.freeItem);

    if (validOrderDetails.length !== validRows.length) return true;

  // Check quantities
  for (const row of validRows) {
    if (
      row?.actualCaseQuantity !== row?.caseQuantity ||
      row?.actualPieceQuantity !== row?.pieceQuantity ||
      row?.actualOtherUnitQuantity !== row?.otherUnitQuantity
    ) {
      return true;
    }
  }

  return false;
};

  const handleQuantityChange = (
    paramRow: any,
    changedQuantity: number,
    type: UOM
  ) => {
    if (changedQuantity >= 0) {
      const quantityInputKey =
        type === UOM.CASE
          ? "caseQuantityInput"
          : type === UOM.OTHER
          ? "otherUnitQuantityInput"
          : "pieceQuantityInput";
      const quantityKey =
        type === UOM.CASE
          ? "caseQuantity"
          : type === UOM.OTHER
          ? "otherUnitQuantity"
          : "pieceQuantity";
      const priceKey =
        type === UOM.CASE
          ? "casePrice"
          : type === UOM.OTHER
          ? "otherUnitPrice"
          : "price";


      let correctedQuantity = changedQuantity;

      updateQuantityInCart(
        paramRow?.batchCode,
        changedQuantity,
        type,
        { outletCode: "self" },
        catalogue,
        setCart
      );

      setRows((prevRows) =>
        prevRows?.map((row) => {
          if (row?.batchCode === paramRow?.batchCode) {
            const newQty = new BigDecimal(correctedQuantity || "0");
            const price = new BigDecimal(paramRow[priceKey] || "0");

            const newAmount = newQty.multiply(price);
            let correctedAmount = newAmount;

              correctedAmount = Number(correctedAmount.getValue()) < 0
                  ? new BigDecimal(0)
                  : correctedAmount;

            return {
              ...row,
              [quantityKey]: correctedQuantity,
              [quantityInputKey]: correctedQuantity.toString(),
              actualAmount: correctedAmount.getValue(), 
            };
          } else {
            return row;
          }
        })
      );
    }
  };

  const getAmountBounds = () => {
    const initialAmount = new BigDecimal(initialNetAmountBeforeSaving.current);
    const percentage = new BigDecimal(arsPercentage).divide(new BigDecimal(100));

    const rawLower = initialAmount.subtract(initialAmount.multiply(percentage));
    const rawUpper = initialAmount.add(initialAmount.multiply(percentage));

    const lowerBound = rawLower.getValue();
    const upperBound = rawUpper.getValue();

    return [Number(lowerBound), Number(upperBound)];
  };

  const getQuantityBounds = (initialQty: number) => {
    const qty = new BigDecimal(initialQty);
    const percentage = new BigDecimal(arsPercentage).divide(new BigDecimal(100));

    const rawLower = qty.multiply(new BigDecimal(1).subtract(percentage));
    const rawUpper = qty.multiply(new BigDecimal(1).add(percentage));

    const lowerBound = roundWithPointSixRule(Number(rawLower.getValue()));
    const upperBound = roundWithPointSixRule(Number(rawUpper.getValue()));

    return [Number(lowerBound), Number(upperBound)];
  };


  const handleOnBlur = (paramRow: any) => {
    if(arsType && arsPercentage) {
      setTextSwitcherItems(default_items);
    }
      const {
        batchCode,
        caseQuantity,
        otherUnitQuantity,
        pieceQuantity,
        casePrice,
        otherUnitPrice,
        price,
        availableStock,
        caseToPieceQty,
        otherToPieceQty,
        uom,
      } = paramRow ?? {};
      let roundedOffNumber = roundWithPointSixRule(Number(paramRow?.caseQuantityInput));
      let convertedCaseQty = arsType ? roundedOffNumber : caseQuantity;
      let convertedOtherQty = otherUnitQuantity;
      let convertedPieceQty = pieceQuantity;
      
      if (paramRow?.source?.toLowerCase() === "ars") {

        let initialCaseQuantity = paramRow?.["actualCaseQuantity"];

        if("quantity" === arsType?.toLowerCase()) {
          const [caseLower, caseUpper] = getQuantityBounds(initialCaseQuantity);
          // Check case quantity range
          if (roundedOffNumber < caseLower) {
            setArsVoilationMsg(`Case quantity cannot be lower than ${caseLower}`);
            setArsVoilation(true);
            convertedCaseQty = caseLower;
          } else if (roundedOffNumber > caseUpper) {
            setArsVoilationMsg(`Case quantity cannot be higher than ${caseUpper}`);
            setArsVoilation(true);
            convertedCaseQty = caseUpper;
          }
        }
      }

      updateMultiQtyInCart(
        batchCode,
        {
          caseQuantity: convertedCaseQty,
          otherUnitQuantity: convertedOtherQty,
          pieceQuantity: convertedPieceQty,
        },
        { outletCode: orderData?.outletCode },
        catalogue,
        setCart
      );

      setRows((prevRows) =>
        prevRows?.map((row) =>
          row?.batchCode === paramRow?.batchCode
            ? {
                ...row,
                caseQuantity: convertedCaseQty,
                otherUnitQuantity: convertedOtherQty,
                pieceQuantity: convertedPieceQty,
                caseQuantityInput: convertedCaseQty,
                otherUnitQuantityInput: convertedOtherQty,
                pieceQuantityInput: convertedPieceQty,
                actualAmount: truncateToTwoDecimals(
                  +row?.actualAmount -
                    (caseQuantity * casePrice +
                      otherUnitQuantity * otherUnitPrice +
                      pieceQuantity * price) +
                    (convertedCaseQty * casePrice +
                      convertedOtherQty * otherUnitPrice +
                      convertedPieceQty * price)
                ),
              }
            : row
        )
      );
    // }
  };

  const handleRemove = (paramRow: any) => {
    updateMultiQtyInCart(
      paramRow?.batchCode,
      {
        caseQuantity: 0,
        otherUnitQuantity: 0,
        pieceQuantity: 0,
      },
      { outletCode: orderData?.outletCode },
      catalogue,
      setCart
    );
    setRows((prevRows) =>
      prevRows?.filter((row) => row?.batchCode !== paramRow?.batchCode)
    );
  };

  const handlePromotionModalVisibility = (paramRow: any) => {
    setSelectedSkuCode(paramRow?.batchCode);
    dispatch(setDiscountModalState(true));
  };


  const columns: any[] = isEditing
    ? [
        ...getViewPrimaryOrderEditConfig(
          toggleTaxInfoCollapsedStatus,
          handleQuantityChange,
          handleOnBlur,
          handleRemove,
          handlePromotionModalVisibility,
          undefined,
          isArsOrderRef.current,
          getAndSetTextSwitcherItems,
          handleInputDecimalChange,
        )?.columns,
      ]
    : [
        ...getViewPrimaryOrderConfig(
          toggleTaxInfoCollapsedStatus,
          handlePromotionModalVisibility,
          showTaxPercentage.current,
          isArsOrderRef.current
        )?.columns,
      ];

  const filteredData = useMemo(() => {
    return filterData(data, searchedValue.toLowerCase(), defaultSearchFunction);
  }, [searchedValue, data]);

  useEffect(() => {
    setRows(filteredData);
  }, [filteredData]);

  const getOrderActionButtons = async () => {
    try {
      const stages = ConfigDictionary?.primaryOrderTrackingStages;
      stages.unshift({
        id: "ALLORDERS",
        color: "#F0F3FF",
        label: "All Orders",
        labelColor: "",
      });
      stagesRef.current = stages;
      setActionButtons(stages);
    } catch (error) {
      console.error(error);
    }
  };

  const getTotalQuantities = (orderData: any, config: any): string[] => {
    const {
      packUnitLabelPrimary,
      caseUnitLabelPrimary,
      otherUnitLabelPrimary,
    } = config;

    return [
      caseUnitLabelPrimary
        ? `${orderData?.totalCaseQuantity} ${caseUnitLabelPrimary}`
        : "",
      otherUnitLabelPrimary
        ? ` ${orderData?.totalOtherUnitQuantity} ${otherUnitLabelPrimary}`
        : "",
      packUnitLabelPrimary
        ? ` ${orderData?.totalPieceQuantity} ${packUnitLabelPrimary}`
        : "",
    ].filter(Boolean); // Removes empty values
  };

  const getAllOrderDetailsDataMethod = async (orderId: string) => {
    try {
      setCurrencySymbol(
        ConfigDictionary?.currency ? ConfigDictionary?.currency : ""
      );
      const orderFulfillmentConfigPrimary =
        ConfigDictionary?.orderFulfillmentTimePrimary
          ? ConfigDictionary?.orderFulfillmentTimePrimary
          : 2;
      const res = await getSinglePrimaryOrder(orderId);
      if (res.status === 200) {
        const data = res?.data?.features?.[0] ?? {};
        setDeliveryDatePrimary(
          dayjs(data?.creationTime)
            .add(orderFulfillmentConfigPrimary, "day")
            .format("YYYY-MM-DD")
        );
        setOrderData(data);
        initialNetAmountBeforeSaving.current = data?.netAmount;
        logEvent(analytics, "primary_order_details_viewed", {
          distributor_id: JSON.parse(localStorage.authContext).user.loginId,
          order_id: data?.id ?? null,
          order_value: data?.totalAmount ?? null,
          company_id: data?.supplier ?? null,
          total_skus: data?.lineCount ?? null,
        });
      }
      await setOrderDataAndRows(res)
    } catch (error) {
      await sendSlackAlert(
        SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
        "Error Fetching Order Details - ViewPrimaryOrder.tsx",
        `Failed to fetch order details for order ${orderId}. Error: ${(error as Error).message}`,
        safeStringify({ error, orderId })
      );
      console.log(error);
      setRows([]);
      setData([]);
      openPopup("Something went wrong", "Error");
    }
  };
  const setOrderDataAndRows = async (res: any, validate?: true) => {
      const orderUomCheckConfig = await getConfigData(
        "catalogue_configuration",
        "orderUomCheck"
      );
      const orderUomCheck = orderUomCheckConfig[0]?.configValue ?? "";
      const dbResult = await getDataFromLocalDb("Product");
      const products: any = dbResult?.data?.[0]?.data ?? {};
      const symbol = ConfigDictionary?.currency ?? "";
      let totalQuantity = 0;
      let totalAmount = 0;
      let totalInitialAmount = 0;
      let totalFinalAmount = 0;
      let taxAmount: number = 0;

      let totalCasesOrderDetail = 0;
      let totalPiecesOrderDetail = 0;
      let totalOthersOrderDetail = 0;

      if (res?.data?.[validate ? "feature" : "features"]?.[0]?.orderDetails?.length > 0) {
        let responseArray: viewPrimaryOrderRowsData[] = [];
            if(!validate) {
              disableARSEdit.current = res?.data?.[validate ? "feature" : "features"]?.[0]?.version !== 0;
            }

        res?.data?.[validate ? "feature" : "features"]?.[0]?.orderDetails
          ?.filter(
            (item: any) =>
              Number(item.caseQuantity) +
                Number(item.pieceQuantity) +
                Number(item.otherUnitQuantity) >
              0
          )
          ?.forEach((item: any, index: any) => {
            const {
              id,
              skuCode,
              source,
              batchCode,
              skuDescription,
              category,
              caseQuantity,
              initialCaseQuantity,
              initialPieceQuantity,
              initialOtherUnitQuantity,
              initialAmount,
              discountValue,
              extendedAttributes,
              netAmount,
              pieceQuantity,
              type,
              otherUnitQuantity,
              billAmount,
              price,
              casePrice,
              otherUnitPrice,
            } = item;

            const formattedPrice = price ?? 0;
            const formattedCasePrice = casePrice ?? 0;
            const formattedOtherPrice = 
              otherUnitPrice ?? 0
            ;
            totalQuantity += Number(caseQuantity);
            totalAmount += Number(billAmount);
            totalInitialAmount += Number(initialAmount);
            totalFinalAmount += Number(netAmount);

            totalCasesOrderDetail += caseQuantity;
            totalPiecesOrderDetail += pieceQuantity;
            totalOthersOrderDetail += otherUnitQuantity;

            const taxInfo = extendedAttributes?.taxInfo;
            const freeItem: boolean = type === "freeItem";

            if (!freeItem) {
              taxInfo?.forEach(
                (taxType: any) => (taxAmount += taxType?.taxAmount || 0)
              );
            }
            if (source?.toLowerCase() === "ars") isArsOrderRef.current = true;

            responseArray.push({
              id,
              source,
              skuCode,
              batchCode,
              skuDescription,
              caseQuantity,
              caseQuantityInput: caseQuantity?.toString(),
              pieceQuantity,
              otherUnitQuantity,
              category,
              pricePerCase: casePrice,
              totalCaseQuantity: caseQuantity,
              actualAmount: initialAmount,
              savedInitialAmount: initialAmount,
              discount: discountValue,
              taxInfo,
              freeItem,
              finalAmount: netAmount,
              casePrice: formattedCasePrice,
              price: formattedPrice,
              otherUnitPrice: formattedOtherPrice,
              uom:
                orderUomCheck === "true"
                  ? products[batchCode]?.uom ?? ""
                  : "all",
              caseToPieceQty:
                products[batchCode]?.caseToPieceQuantity ??
                extendedAttributes?.["caseToPiece"] ??
                99999,
              otherToPieceQty:
                products[batchCode]?.otherUnitToPieceQuantity ?? 99999,
              collapsed: true,
              actualCaseQuantity: initialCaseQuantity,
              actualPieceQuantity: initialPieceQuantity,
              actualOtherUnitQuantity: initialOtherUnitQuantity,
            });
          });
        setTotalFooterValue([
          { headerName: "SKU Code", total: "Total" },
          {
            headerName: "Cases",
            total: totalCasesOrderDetail,
            textAlign: "center",
          },
          {
            headerName: "Pieces",
            total: totalPiecesOrderDetail,
            textAlign: "center",
          },
          {
            headerName: "Others",
            total: totalOthersOrderDetail,
            textAlign: "center",
          },
          {
            headerName: "Amount",
            total: truncateToTwoDecimals(totalInitialAmount),
            textAlign: "left",
            currencySymbol: symbol,
          },

          {
            headerName: "Final Amount",
            total: truncateToTwoDecimals(totalFinalAmount),
            textAlign: "left",
            currencySymbol: symbol,
          },
        ]);
        setRows(responseArray);
        setData(responseArray);
        setTotalTaxAmount(taxAmount);
      } else {
        throw new Error();
      }
  }
  const handleSearchValueChange = (newValue: string) => {
    setSearchedValue(newValue);
  };

  const resetGenericModalProps = () =>
    setGenericModalProps(initialGenericModalProps);
  // those rows are valid which are not a free product
  const validRows = [...rows]?.filter(
    (row: viewPrimaryOrderRowsData) => !row?.freeItem
  );

  const openInvalidOrderModal = () => {
    if (!orderData?.orderNumber && !orderData?.id) {
      setGenericModalProps(
        getGenericModalProps("error", `Invalid order, cannot proceed`)
      );
      return true;
    } else {
      return false;
    }
  };
  const prepareEditOrderReqBody = (
    orderValidateResponse: any,
    rows: viewPrimaryOrderRowsData[]
  ) => {
    const filteredOrderValidateResponse: { [key: string]: any } = {};

    keysToKeep.forEach((key) => {
      if (orderValidateResponse.hasOwnProperty(key)) {
        filteredOrderValidateResponse[key] = orderValidateResponse[key];
        if (key === "orderDetails") {
          let orderDetailsFullNodes = filteredOrderValidateResponse[key];
          const filteredOrderDetailsArray: any = [];

          orderDetailsFullNodes.forEach((orderDetailsFullNode: any) => {
            const filteredOrderDetails: { [key: string]: any } = {};
            keysToKeepOD.forEach((odKey: any) => {
              if (orderDetailsFullNode.hasOwnProperty(odKey)) {
                filteredOrderDetails[odKey] = orderDetailsFullNode[odKey];
              }
            });
            filteredOrderDetailsArray.push(filteredOrderDetails);
          });

          filteredOrderValidateResponse[key] = filteredOrderDetailsArray;
        }
      }
    });

    orderValidateResponse = filteredOrderValidateResponse;

    orderValidateResponse["finalOrderInfo"] = {
      quantity: orderValidateResponse["orderDetails"].map((row: any) => {
        const { batchCode, caseQuantity, pieceQuantity, otherUnitQuantity } =
          row;
        return {
          batchCode: batchCode || "",
          caseQuantity: caseQuantity || 0,
          pieceQuantity: pieceQuantity || 0,
          otherUnitQuantity: otherUnitQuantity || 0,
        };
      }),
      finalAmount: orderValidateResponse?.billAmount,
    };

    delete orderValidateResponse["extendedAttributes"]["orderValidate"];

    orderValidateResponse["orderDetails"] = orderValidateResponse[
      "orderDetails"
    ]
      ?.map((obj: any) => {
        const targetRow = rows?.find(
          (row: any) => row.batchCode === obj.batchCode
        );
        if (!targetRow || obj?.type == "freeItem") return null;
        return {
          ...obj,
          caseQuantity: targetRow.caseQuantity,
          pieceQuantity: targetRow.pieceQuantity,
          otherUnitQuantity: targetRow.otherUnitQuantity,
        };
      })
      .filter(Boolean);

    return orderValidateResponse;
  };

  const fetchRequiredConfigs = async () => {
    try {
      const res3 = await getConfigData(
        "dms_configuration",
        "disableStockCheck"
      );
      const res11 = await getConfigData(
        "dms_configuration",
        "useNewOrderStatusUpdateAPI"
      );
      const res7 = await getConfigData(
        "dms_configuration",
        "disableSchemeCheck"
      );
      const statusConfig = await getConfigData(
        "order_configuration",
        "orderTrackingStages"
      );
      const rejectionReasonsConfig = await getConfigData(
        "dms_configuration",
        "orderCancellationReasons"
      );
      const enableARSConfigV = await getConfigData(
              "dms_configuration",
              "enableARSConfig"
            );
      const showTaxPercentageConfig = await getConfigData(
        "dms_configuration",
        "showTaxPercentage"
      );

      enableARSConfig.current = enableARSConfigV[0]?.configValue ?? false;
      useNewOrderStatusUpdateAPI.current = res11[0]?.configValue ?? false;
      disableSchemeCheck.current = res7[0]?.configValue ?? false;
      disableStockCheck.current = res3[0]?.configValue ?? false;
      showTaxPercentage.current = showTaxPercentageConfig[0]?.configValue ?? true;
      setRejectionReasons(rejectionReasonsConfig?.[0]?.configValue ?? []);
      setOrderTrackingConfig(statusConfig[0]?.configValue ?? []);
    } catch (error) {
      await sendSlackAlert(
        SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
        "Error Fetching Configurations - ViewPrimaryOrder.tsx",
        `Failed to fetch configuration. Error: ${(error as Error).message}`,
        safeStringify({ error})
      );
      console.error("Error while fetching configs", error);
    }
  };

  const handleValidate = async () => {
      const modifiedCart: any = await modifyCartToValidate(
        setCart,
        orderData
      );
      const requestBody: Record<any, any> | null = getValidateRequestBody(
        modifiedCart?.[orderData?.outletCode],
        orderData,
        true,
        undefined,
        undefined,
        isArsOrderRef.current
      );

      if (requestBody) {
        if(isArsOrderRef.current) requestBody["orderNumber"] = orderData?.orderNumber;
        const response = await ChannelkartNetworkPost(
          "/orders/validate?transformerOut=orderDetailSplit",
          requestBody
        );
        if (response?.status === 200 || response?.status === 201) {
          const data = response?.data?.feature?.[0] ?? {};
          setOrderData(data);
          await setOrderDataAndRows(response, true);
          const [lowerBound, upperBound] = getAmountBounds();

          if(data?.netAmount >= lowerBound && data?.netAmount <= upperBound) {
            setIstARSAmountValid(true);
            setTextSwitcherItemsForAmountTrail([]);
          } else {
            setIstARSAmountValid(false);
            let isLower = data?.netAmount < lowerBound ;
            const items: TextSwitcherItemObject[] = [
              {
                // text: isLower
                //   ? `Amount is below by ${truncateToTwoDecimals(lowerBound - data?.netAmount)}`
                //   : `Amount exceeds by ${truncateToTwoDecimals(data?.netAmount - upperBound)}`,
                text: "Please adjust the quantity to meet the required order amount to save.",
                svgIcon: "disclaimerIcon",
                itemStyles: {
                  container: { backgroundColor: "#FFF1F1" },
                  text: { color: "#B54747" },
                  svg: { color: "#B54747", width: "1em" },
                },
              },
            ];

            setTextSwitcherItemsForAmountTrail(items);
          }
        }
      }
  }

  const handleSaveQuantityChanges = async () => {
    const validOrderData = JSON.parse(JSON.stringify(orderData));
    const validOrderDetails = validOrderData?.orderDetails?.filter(
      (sku: any) => sku?.type !== `freeItem`
    );
    validOrderData.orderDetails = validOrderDetails;

    const modifiedCart: any = await modifyCartToValidate(
      setCart,
      validOrderData
    );

    let editedSkus: string[] = [];
    let editedCQ: number = 0;
    let editedPQ: number = 0;
    let editedOUQ: number = 0;

    for (const row of rows) {
      if (
        row?.actualCaseQuantity !== row?.caseQuantity ||
        row?.actualPieceQuantity !== row?.pieceQuantity ||
        row?.actualOtherUnitQuantity !== row?.otherUnitQuantity
      ) {
        // Accumulate the edited quantities if changes are detected
        if (row?.actualCaseQuantity !== row?.caseQuantity) {
          editedCQ += row?.actualCaseQuantity - row?.caseQuantity;
        }

        if (row?.actualPieceQuantity !== row?.pieceQuantity) {
          editedPQ += row?.actualPieceQuantity - row?.pieceQuantity;
        }

        if (row?.actualOtherUnitQuantity !== row?.otherUnitQuantity) {
          editedOUQ += row?.actualOtherUnitQuantity - row?.otherUnitQuantity;
        }

        if (editedCQ !== 0 || editedPQ !== 0 || editedOUQ !== 0) {
          editedSkus.push(row?.batchCode ?? "");
        }
      }
    }

    try {
      setOrderStatusChangeLoading("SAVE_CHANGES");
      const requestBody: Record<any, any> | null = getValidateRequestBody(
        modifiedCart?.[validOrderData?.outletCode],
        validOrderData,
        true,
        undefined,
        undefined,
        isArsOrderRef.current
      );

      if (requestBody) {
        if(isArsOrderRef.current) {
          requestBody.orderNumber = orderData?.orderNumber;
        }
        const response = await ChannelkartNetworkPost(
          "/orders/validate?transformerOut=orderDetailSplit",
          requestBody
        );
        if (response?.status === 200 || response?.status === 201) {
          const validateResponse = response?.data?.feature?.[0];
          delete validateResponse["creationTime"];
          const orderPutPayload = prepareEditOrderReqBody(
            validateResponse,
            validRows
          );
          await updateOrder(orderPutPayload, validOrderData?.orderNumber);

          let prevBatchCodes: string[] =
            orderData?.orderDetails?.map((s: any) => s?.batchCode).collect ??
            [];
          let newBatchCodes: string[] =
            validateResponse?.orderDetails?.map((s: any) => s?.batchCode)
              .collect ?? [];
          let uniqueNewBatchCodes = newBatchCodes
            ?.filter((code) => !prevBatchCodes?.includes(code))
            .join(",");
          let uniqueNewBatchCodesNormalizedQuantity =
            validateResponse?.orderDetails
              ?.filter((s: any) => uniqueNewBatchCodes?.includes(s?.batchCode))
              ?.reduce(
                (sum: number, s: any) => sum + (s?.normalizedQuantity || 0),
                0
              );

          logEvent(analytics, "primary_ars_order_edited", {
            distributor_id: JSON.parse(localStorage.authContext).user.loginId,
            order_id: orderData?.id ?? null,
            edited_skus: editedSkus?.join(",") ?? "", // Join editedSkus array if exists, fallback to empty string if undefined
            edited_qty:
              formatEditedQuantities(editedCQ, editedPQ, editedOUQ) ?? 0, // Ensure a fallback value of 0 if function returns undefined
            total_discount:
              validateResponse?.discountInfo?.[0]?.discount ?? null, // Safely access discount or fallback to null
            added_skus: uniqueNewBatchCodes ?? [], // Default to an empty array if uniqueNewBatchCodes is undefined
            added_qty: uniqueNewBatchCodesNormalizedQuantity ?? 0, // Default to 0 if uniqueNewBatchCodesNormalizedQuantity is undefined
          });
        }
      }

      resetGenericModalProps();
      refresh();
    } catch (e) {
      console.error(e);
      await sendSlackAlert(
        SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
        "Error Saving Order Changes - ViewPrimaryOrder.tsx",
        `Failed to save quantity changes for order ${orderId}. Error: ${(e as Error).message}`,
        safeStringify({ e, orderId, orderData, rows, modifiedCart })
      );
      setGenericModalProps(
        getGenericModalProps("error", `Error while saving the changes`)
      );
    } finally {
      setOrderStatusChangeLoading("");
    }
  };

  const getOrderCancellationStatusId = () => {
    return orderTrackingConfig?.some(
      (status: any) => status?.id?.toUpperCase() === "CANCELLED"
    )
      ? "Cancelled"
      : "REJECTED";
  };

  const handleOrderStatusChange = async (id: string) => {
    const isCancellingOrderOrInvoice: boolean =
      id?.toUpperCase() == "REJECTED" || id?.toUpperCase() == "CANCELLED";

    let requestBody;


    requestBody = {
      status: id,
      statusReason: selectedRejectionReason
    };

    setOrderStatusChangeLoading(id);

    try {
      if (id?.toUpperCase() == "CONFIRMED") {
        logEvent(analytics, "primary_order_confirmed", {
          distributor_id: JSON.parse(localStorage.authContext).user.loginId,
          order: orderData?.id ?? null,
          confirmed_skus:
            (orderData?.orderDetails?.map((s: any) => s?.batchCode) || []).join(
              ","
            ) || "",
          confirmed_qty: orderData?.normalizedQuantity || "",
          final_amount: orderData?.netAmount || "",
          total_discount: orderData?.discountInfo?.[0]?.discount || "",
        });
      } else if (isCancellingOrderOrInvoice) {
        logEvent(analytics, "primary_order_rejected", {
          distributor_id: JSON.parse(localStorage.authContext).user.loginId,
          order: orderData?.id ?? null,
          rejected_skus:
            (orderData?.orderDetails?.map((s: any) => s?.batchCode) || []).join(
              ","
            ) || "",
          rejected_qty: orderData?.normalizedQuantity || "",
          final_amount: orderData?.netAmount || "",
          total_discount: orderData?.discountInfo?.[0]?.discount || "",
        });
      }
      await updateOrderStatus(
        requestBody,
        orderData?.orderNumber,
        useNewOrderStatusUpdateAPI.current
      );
      await fetchData();

      resetGenericModalProps();
    } catch (e) {
      await sendSlackAlert(
        SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
        "Error Updating Order Status - ViewPrimaryOrder.tsx",
        `Failed to update order status to ${id} for order ${orderData?.orderNumber}. Error: ${(e as Error).message}`,
        safeStringify({ e, orderId, orderData, status: id, selectedRejectionReason })
      );
      setGenericModalProps(
        getGenericModalProps("error", `Error while updating order status`)
      );
    } finally {
      setOrderStatusChangeLoading("");
      setIsEditing(false);
      if (isCancellingOrderOrInvoice) resetRejectOrderState();
    }
  };

  const resetRejectOrderState = () => {
    setOrderCancelModalOpen(false);
    setSelectedRejectionReason("");
    setRejectionReasonString("");
  };

  async function handleClickAccept() {
    if (openInvalidOrderModal()) return;

    let message = `Are you sure you want to Confirm the order?`;

    const fn = () =>
      logLoadTrace(
        () => handleOrderStatusChange("CONFIRMED"),
        "secondary_order_confirm_order_time"
      );
    const leftBtnText = "Yes";
    const rightBtnText = "No";

    const updatedGenericModalProps = getGenericModalProps(
      "positive",
      message,
      leftBtnText,
      rightBtnText,
      fn,
      resetGenericModalProps
    );
    setGenericModalProps(updatedGenericModalProps);
  }

  const handleReasonChange = (reason: string) => {
    setSelectedRejectionReason(reason);
  };

  const handleReasonStringChange = (reason: string) => {
    setRejectionReasonString(reason);
  };

  const refresh = () => {
    setIsEditing(false);
    setLoader(true);
    Promise.allSettled([fetchData(), fetchRequiredConfigs()]).finally(() => {
      setLoader(false);
    });
  };

  const handleCancel = async () => {
    setIstARSAmountValid(false);
    setEditLoading(true);
    await handleReset();
    setIsEditing(false);
    setEditLoading(false);
    setTextSwitcherItemsForAmountTrail([])
  };
  const handleReset = async () => {
    setSearchedValue("");
    if (orderId) {
      await getAllOrderDetailsDataMethod(orderId);
      setIstARSAmountValid(arsType?.toLowerCase() !== "amount");
      setTextSwitcherItemsForAmountTrail([])
    } else {
      navigate("/dashboard/primaryOrder", { replace: true });
      return;
    }
  };

  const handleDisableEditing = () => {
    handleReset();
    resetGenericModalProps();
    setIsEditing(false);
  };

  const fetchData = async () => {
    if (orderId) {
      // Start a custom trace for manage secondary order bulk invoice page load time
      const pageLoadTrace: PerformanceTrace = trace(
        performance,
        "view_primary_order_page_load_time"
      );
      pageLoadTrace.start();
      setLoader(true);

      // Wait for all promises to settle before stopping the trace
      await Promise.allSettled([
        getAllOrderDetailsDataMethod(orderId),
        getOrderActionButtons(),
        fetchRequiredConfigs(),
      ]).finally(() => {
        setLoader(false);
      });

      pageLoadTrace.stop();
    } else {
      navigate("/dashboard/primaryOrder", { replace: true });
      return;
    }
  };

  useEffect(() => {
    fetchData(); // Call the async function inside the effect
  }, [orderId]);

  const checkForEmptyTable = (rows: viewPrimaryOrderRowsData[]) => {
    const result = rows?.every((item) => {
      return (
        item?.caseQuantity === 0 &&
        item?.pieceQuantity === 0 &&
        item?.otherUnitQuantity === 0
      );
    });
    return result;
  };
  const handleClickSaveChanges = async () => {
    if (openInvalidOrderModal()) return;

    setSaveChangesLoading(true);
    const isEmptyTable = checkForEmptyTable(validRows);
    setSaveChangesLoading(false);

    let message = "";

    message = `Do you wish to save the changes made? ${
      isEmptyTable ? "Disclaimer: your order will be rejected." : ""
    }`;

    const leftBtnFn = () => handleSaveQuantityChanges();

    const rightBtnFn = async () => {
      handleDisableEditing();
    };

    const leftBtnText = "Yes";
    const rightBtnText = "Close";

    const updatedGenericModalProps = getGenericModalProps(
      "positive",
      message,
      leftBtnText,
      rightBtnText,
      leftBtnFn,
      rightBtnFn,
      undefined,
      undefined,
      undefined,
      undefined,
      "455px"
    );
    setGenericModalProps(updatedGenericModalProps);
  };

  const handleSnackbarClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setArsVoilation(false);
  };
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const handler = createScrollHandler(
      scrollRef,
      isScrolling,
      setAllowTableScroll,
      setDontContainerScroll
    );

    el.addEventListener("wheel", handler);
    el.addEventListener("scroll", handler);

    return () => {
      el.removeEventListener("wheel", handler);
      el.removeEventListener("scroll", handler);
    };
  }, [isScrolling, dontAllowContainerScroll]);

  useEffect(() => {
    if (!rows.length || !orderData) return;
    let disable = !hasRealChanges();
    setDisableActionButtons(disable);
    if(!disable && isARSAmountValid && "amount" === arsType?.toLowerCase()) setIstARSAmountValid("amount" !== arsType?.toLowerCase())
  }, [rows, orderData, isEditing]);


  if (loader) {
    return <Loader />;
  }


  return (
    <>
      <ConfirmationPopUp
        openConfirmModal={confirmationPopUp}
        message={popUpMessage}
        setOpenConfirmModal={() => {
          setConfirmationPopUp(false);
        }}
        successMethod={popUpSuccessMethod.current}
      />
      <GenericPopUp
        message={genericMessage}
        type={popupType}
        openGenericModal={openGenericModal}
        setOpenGenericModal={setOpenGenericModal}
      />
      <Snackbar
        open={arsVoilation}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
      >
      {enableARSConfig.current ? (<Alert
          onClose={handleSnackbarClose}
          severity="warning"
          sx={{ width: "100%" }}
        >
        {arsVoilationMsg}
        </Alert>) : (<></>)}
      </Snackbar>
      <CustomGenericModal
        type={genericModalProps?.type}
        message={genericModalProps?.message}
        leftButtonText={genericModalProps?.leftButtonText}
        rightButtonText={genericModalProps?.rightButtonText}
        modalOpen={genericModalProps?.open}
        onLeftButtonClick={genericModalProps?.onLeftButtonClick}
        onRightButtonClick={genericModalProps?.onRightButtonClick}
        leftButtonPadding={genericModalProps?.leftButtonPadding}
        onClose={resetGenericModalProps}
        loading={Boolean(orderStatusChangeLoading?.length)}
        width={genericModalProps?.width}
      />
      <NewDiscountModalPrimary
        skuData={orderData}
        selectedSkuCode={selectedSkuCode}
      />
    <div className="view_order_parent_vo" onWheel={(e) => handleScroll(e, setIsScrolling, scrollTop)}>
        <div className="view_order_header_with_search">
          <div className="view_order_header">
            <FormHeader
              parentLabel={"View Primary Order"}
              label={"Order Details"}
              goBackToParent={() => navigate('/dashboard/purchase/viewPrimaryOrders', { state: { ars: orderData?.source?.toLowerCase() === "ars" } })}
            />
          </div>
          <div style={{ width: "25%" }}>
            <Search searchFunction={handleSearchValueChange} />
          </div>
        </div>
        <div ref={scrollRef} style={{
          gap: "14px",
          overflow: (ConfigDictionary?.showTableScrollbar ? "auto" : (dontAllowContainerScroll ? "hidden" : "auto")), 
          height: "100%",
          scrollbarWidth: ConfigDictionary?.showTableScrollbar ? "thin" : "none",
        }}
          onScroll={(e) => {
            if (ConfigDictionary?.showTableScrollbar){
              const currentScrollTop = e.currentTarget.scrollTop;
              if (currentScrollTop > scrollTop) {
                setIsScrolling(true); // scrolling down
              } else if (currentScrollTop < scrollTop) {
                setIsScrolling(false); // scrolling up
              } 
            }
          }} 
        >
          <CustomAccordian
            expanded={!isScrolling}
            rejectionReason={((orderData?.status?.toLowerCase()==="cancelled" || orderData.status?.toLowerCase()==="rejected") && orderData.statusReason) ?  orderData.statusReason : ""}
            onCustomAccordionToggle={onCustomAccordionToggle}
            isSecondHalf={true}
            metaData1={getMetaData1(
              ConfigDictionary?.currency ? ConfigDictionary?.currency : ""
            )}
            data1={{
              totalCasePieceOtherQuantity: getTotalQuantities(
                orderData,
                ConfigDictionary
              ),
              totalQuantity: orderData?.lineCount,
              netAmount: truncateToTwoDecimals(orderData?.totalAmount),
              discountValue: truncateToTwoDecimals(orderData?.totalDiscountValue),
              taxAmount: truncateToTwoDecimals(totalTaxAmount),
              billAmount: truncateToTwoDecimals(orderData?.netAmount),
            }}
            metaData2={metaData2()}
            data2={{
              supplierCode: orderData?.primarySupplier ?? orderData?.supplier,
              supplierName: orderData?.primarySupplierName ?? orderData?.supplierName,
              deliveryDate: deliveryDatePrimary,
              vechileNumber: orderData?.vechileNumber ?? "-",
              dispatchDate: orderData?.dispatchDate ? dayjs(orderData?.dispatchDate).format("YYYY-MM-DD") : "-",
              grnActionTime: orderData?.grnActionTime ?? "-",
            }}
            header={`Order No. ${orderData?.orderNumber}`}
            label1="Order Summary"
            label2="Supplier Summary"
            dateAndTimeLabel="Order time & date"
            dateAndTimeValue={orderData?.creationTime}
            statusConfig={actionButtons}
            status={orderData?.status}
            redirectionUrl={`/dashboard/purchase/viewPrimaryOrders/viewGrnDetails/${encodeURIComponent(
              orderData?.invoiceNumber ?? ""
            )}`}
          />
          <div style={{height: "100%", position: "sticky", top: "0"}}>
            <div className="view_order_details_vo">
              <div className="ViewPrimaryOrder-view_order_button_container"
              style={{
               padding: "8px 0" 
              }}
              >
                <BorderHeading>Order Details</BorderHeading>
                <TextSwitcher textSwitcherItems={textSwitcherItems ?? []} interval={3000}/>
                {orderData?.status?.toUpperCase() === "REJECTED" ||
                orderData?.status?.toUpperCase() === "CANCELLED" ||
                orderData?.status?.toUpperCase() === "OUT FOR DELIVERY" ||
                orderData?.status?.toUpperCase() === "DELIVERED" ||
                orderData?.status?.toUpperCase() === "PARTIAL DELIVERED" ||
                orderData?.status?.toUpperCase() === "INVOICED" ? (
                  <></>
                ) : (
                  <div style={{ display: "flex", gap: "8px" }}>
                    {isEditing ? (
                      <Button
                        className="ViewPrimaryOrder-view_order_reset_button"
                        onClick={async () => {
                          if (editLoading) return;
                          setEditLoading(true);
                          await handleReset();
                          setEditLoading(false);
                        }}
                        sx={{
                          borderColor: isEditing ? "#00000042 !important" : "",
                          background: "none",
                          color: "rgb(28, 126, 160)",

                          "&:hover": {
                            background: "none",
                          },
                        }}
                      >
                        <div className="ViewPrimaryOrder-view_order_icon_wrapper">
                          <RenderSvg name={"backIcon"} />
                        </div>{" "}
                        Reset changes
                      </Button>
                    ) : null}

                    {isArsOrderRef.current && !disableARSEdit.current && !isEditing && (orderData?.status?.toUpperCase() === "PENDING") && (
                      <Button
                        className="ViewPrimaryOrder-view_order_reset_button"
                        disabled={
                          isEditing ||
                          (arsType?.toLowerCase() === "amount" &&
                            Number(arsPercentage) === 0)
                        }
                        onClick={async () => {
                          if (editLoading) return;
                          if (openInvalidOrderModal()) return;
                          setEditLoading(true);
                          const res = await populateCartDuringEditOrder(orderData);
                          if (res === "invalidPricing") {
                            setEditLoading(false);
                            return;
                          }
                          setSnackbarOpen(true);
                          setEditLoading(false);
                          setIsEditing(true);
                        }}
                        sx={{
                          gap: "2px",
                          minHeight: "34px",
                          minWidth: "71px",
                          cursor: "pointer",
                          borderColor: isEditing ? "#00000042 !important" : "",
                          background: "none",
                          color: "rgb(28, 126, 160)",

                          "&:hover": {
                            background: "none",
                          },
                        }}
                      >
                        <div className="ViewPrimaryOrder-view_order_icon_wrapper">
                          <RenderSvg name={"viewAndEditIcon"} />
                        </div>
                        Edit
                      </Button>
                    )}

                  </div>
                )}
              </div>
                {loader ? (
                  <Loader />
                ) : (
                  <>
                    
                    <CustomTablewithTotalInfo
                      data={rows}
                      columns={columns}
                      totals={totalFooterValue}
                      allowTableScroll={allowTableScroll}
                      setScrollTop={setScrollTop}
                      headerBackgroundColor="#F0FBFF"
                      isEditing={isEditing}
                      isArs={enableARSConfig.current && isArsOrderRef.current}
                      children={
                        isArsOrderRef.current ? (
                          orderData?.status?.toUpperCase() === "PENDING" ? (
                            <PendingButtons
                            isPrimary={true}
                              showPushToGrnButton={false}
                              batchIdConfiguration={batchIdConfiguration}
                              handleCreateInvoice={() =>{}}
                              handleClickAccept={handleClickAccept}
                              handleClickReject={() => setOrderCancelModalOpen(true)}
                              isEditing={isEditing}
                              handleClickSaveChanges={handleClickSaveChanges}
                              handleCancel={handleCancel}
                              orderStatusChangeLoading={orderStatusChangeLoading}
                              saveChangesLoading={saveChangesLoading}
                              handleSync={handleValidate}
                              isARSAmount={isArsOrderRef.current && arsType?.toLowerCase() === "amount"}
                              arsAmountValid={arsType?.toLowerCase() === "amount" ? (isArsOrderRef.current && (isARSAmountValid)) : true}
                              textSwitcherItems={textSwitcherItemsForAmountTrail}
                              disableActionButtons={disableActionButtons}
                            />
                          ) : (
                            <></>
                          )
                        ) : (
                          <></>
                        )
                      }
                    />
                  </>
                )}
            </div>
          </div>
        </div>
      <OrderCancelModal
        headerText={`Order is being cancelled.`}
        modalOpen={orderCancelModalOpen}
        selectedRejectionReason={selectedRejectionReason}
        loading={
          buttonLoading(orderStatusChangeLoading, "CANCELLED") ||
          buttonLoading(orderStatusChangeLoading, "REJECTED")
        }
        rejectionReasons={rejectionReasons}
        onClose={resetRejectOrderState}
        handleReasonChange={handleReasonChange}
        onButtonClick={() =>
          logLoadTrace(
            () => handleOrderStatusChange(getOrderCancellationStatusId()),
            "secondary_order_reject_order_time"
          )
        }
        inputString={rejectionReasonString}
        handleReasonStringChange={handleReasonStringChange}
      />
    </div>
    </>
  );
};

export default ViewPrimaryOrder;
